import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { StripeProvider } from "react-stripe-elements";
import * as serviceWorker from "./serviceWorker";
import { STRIPE_KEY } from './serverDetails';

ReactDOM.render(
  <StripeProvider apiKey={STRIPE_KEY}>
    <App />
  </StripeProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
